import { JSX } from 'react'
import { StepConfig } from '@Components/claim-form-flow/types'
import { ClaimReservationCommunicationMethod } from '@interaction-gaming/player-data-service-browser-client'

export type ClaimFormHostConfig = {
  steps: StepConfig[]
  legalText: JSX.Element
  gameTypeHelp: {
    title: string
    content: JSX.Element
  }
  confirmation: {
    backgroundImage: string
    heroImage?: string
    title: string
    message: JSX.Element
  }
}

/** Per-customer brand presentation. */
export type HostBranding = {
  /** Navigation bar, floating footer, dark information panels, and the confirmation background tint. */
  brandColor: string
  /** Text and icons rendered on the navigation bar. */
  navigationFontColor: string
  /** Primary action buttons. */
  ctaColor: string
  /** Selected and completed states: location and timeslot cards, calendar day, progress stepper. */
  accentColor: string
  /** Page background. */
  backgroundColor: string
  /** Font family name without quotes (e.g. "Fira Sans"). Must be loaded by `index.html`. */
  fontFamily: string
}

export type HostConfig = {
  standardFlowRangeInCents: {
    min: number
    max: number
  }
  /** Display suffix appended to claim center names (e.g. "Claim Center" → "Saginaw Claim Center"). */
  claimCenterNameSuffix?: string
  /** IANA timezone the customer's scheduled business-rule cutovers are evaluated in (e.g. "America/Detroit"). */
  timezone?: string
  branding: HostBranding
  /**
   * Channels the customer can reach players on. A player is only asked to choose when more than one
   * is listed; with a single entry they are placed on it. Must not be empty.
   */
  enabledCommunicationMethods: ClaimReservationCommunicationMethod[]
  playerInformation: {
    phoneConsentLabel: JSX.Element
    emailConsentLabel: JSX.Element
    agreeToTermsLabel: JSX.Element
    minAgeForPhoneVerification: number
    ageForVerificationError: string
  }
  reasonForVisitScreen: {
    prizeAmountDisclaimer: JSX.Element
  }
  bookableScreen: {
    header: string
    subHeader: string
  }
  confirmationScreen: {
    /** Background image behind the appointment details. */
    backgroundImage: string
    itemsNeeded: string[]
    disclaimer: JSX.Element
    additionalSections: JSX.Element[]
    claimFormSections?: (beginClaimForm: () => void) => JSX.Element[]
  }
  bigWinnerFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  damagedTicketFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  unknownWinFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  regularTicketFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  manyTicketsFlow: {
    ticketThreshold: number
    backgroundImage: string
    details: JSX.Element[]
  }
  calendarEvent: {
    details: string
    title: string
  }
  claimFormConfig?: ClaimFormHostConfig
}

export enum HOST_NAMES {
  MSL = 'msl',
  GAMBYT_DEMO = 'gambyt-demo',
}
